import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../core/data/redux/store';
import {
  createAdminUser,
  getAllAdminUsers,
  updateAdminUser,
} from '../../../../services/adminServices';
import { UpdateAdminDto } from '../../../../entities/AdminDtos/UpdateAdminDto';
import { rowdatas } from '../../../../core/models/interface';
import { Toast } from 'primereact/toast';
import { Modal } from 'bootstrap';
import { UserRoles } from '../../../../app/common/constants/userRoles';

const UsersModal = ({
  selectedUser,
  setIsAddModalOpen,
  isAddModalOpen,
  isEditModalOpen,
  setIsEditModalOpen,
}: {
  selectedUser: rowdatas | null;
  setIsAddModalOpen: (value: boolean) => void;
  isAddModalOpen: boolean;
  isEditModalOpen: boolean;
  setIsEditModalOpen: (value: boolean) => void;
}) => {
  const toast = useRef<Toast>(null);
  const { adminUserCreated, adminUserUpdated, isError, errorMessage } =
    useSelector((state: any) => state.admin);
  const [admin, setAdmin] = useState({
    username: '',
    password: '',
    role: UserRoles.SUPER_ADMIN,
  });
  const dispatch = useDispatch<AppDispatch>();
  const [selectedValue, setSelectedValue] = useState<any>({
    name: 'Super Admin',
    code: UserRoles.SUPER_ADMIN,
  });
  const roles = [
    { name: 'Admin', code: 'admin' },
    { name: 'Super Admin', code: UserRoles.SUPER_ADMIN },
  ];
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [updatedUser, setUpdatedUser] = useState<rowdatas>({
    id: selectedUser?.id || '',
    username: selectedUser?.username || '',
    role: selectedUser?.role || UserRoles.SUPER_ADMIN,
  });
  const [selectedRole, setSelectedRole] = useState<any>(null);
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedUser) {
      const currentRole = roles.find((role) => role.code === selectedUser.role);
      setSelectedRole(currentRole);
      setUpdatedUser({
        id: selectedUser.id,
        username: selectedUser.username,
        role: selectedUser.role,
      });
    }
  }, [selectedUser]);

  useEffect(() => {
    if (selectedUser) {
      //setIsActive(selectedUser.is_active || false);
    }
  }, [selectedUser]);

  const handleCreateAdminUser = async (e: React.FormEvent) => {
    try {
      setIsLoading(true);
      console.log('handleCreateAdminUser');

      e.preventDefault();

      await dispatch(createAdminUser(admin, setIsAddModalOpen));
      setAdmin({ username: '', password: '', role: UserRoles.SUPER_ADMIN });
      setSelectedValue({ name: 'Super Admin', code:  UserRoles.SUPER_ADMIN });
    } catch (error) {
      console.log('handleCreateAdminUser error', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateAdminUser = (e: React.FormEvent) => {
    try {
      setIsLoading(true);
      e.preventDefault();
      const accessToken = localStorage.getItem('accessToken');
      if (accessToken && selectedUser) {
        dispatch(
          updateAdminUser(
            accessToken,
            {
              ...updatedUser,
              is_active: isActive,
              is_deleted: false,
            },
            () => {
              setIsEditModalOpen(false);
              const backdrop = document.querySelector('.modal-backdrop');
              if (backdrop) {
                backdrop.remove();
              }
              document.body.classList.remove('modal-open');
              document.body.style.overflow = '';
              document.body.style.paddingRight = '';
            },
          ),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAdmin((prevState) => ({ ...prevState, [name]: value }));
    setUpdatedUser((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedRole = roles.find((role) => role.code === e.target.value);
    setSelectedValue(selectedRole || roles[0]);
    setAdmin((prevState:any) => ({ ...prevState, role: e.target.value }));
    setUpdatedUser((prevState) => ({ ...prevState, role: e.target.value }));
  };

  const handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsActive(e.target.checked);
    setUpdatedUser((prevState) => ({
      ...prevState,
      is_active: e.target.checked,
    }));
  };

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (adminUserCreated) {
      toast.current?.show({
        severity: 'success',
        summary: 'Başarılı',
        detail: 'Kullanıcı başarıyla oluşturuldu',
        life: 3000,
      });
      if (accessToken) {
        dispatch(getAllAdminUsers());
      }
    }
  }, [adminUserCreated]);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (adminUserUpdated) {
      toast.current?.show({
        severity: 'success',
        summary: 'Başarılı',
        detail: 'Kullanıcı başarıyla güncellendi',
        life: 3000,
      });

      if (accessToken) {
        dispatch(getAllAdminUsers());
      }
    }
  }, [adminUserUpdated]);

  useEffect(() => {
    if (isError) {
      toast.current?.show({
        severity: 'error',
        summary: 'Hata',
        detail: errorMessage || 'Bir hata oluştu',
        life: 3000,
      });
    }
  }, [isError, errorMessage]);

  return (
    <>
      <Toast ref={toast} />
      <div
        className={`modal fade ${isAddModalOpen ? 'show' : ''}`}
        id="add-user"
        style={{ display: isAddModalOpen ? 'block' : 'none' }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Kullanıcı Ekle</h5>
              <button
                type="button"
                className="btn-close close-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setIsAddModalOpen(false)}
              >
                <Icon.X className="react-feather-custom"></Icon.X>
              </button>
            </div>
            <div className="modal-body pt-0">
              <form onSubmit={handleCreateAdminUser}>
                <div className="mb-3 mt-3">
                  <label className="form-label">Kullanıcı Adı</label>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    value={admin.username}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Şifre</label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control pass-input"
                      name="password"
                      value={admin.password}
                      onChange={handleInputChange}
                    />
                    <span
                      className="fas toggle-password"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <Icon.EyeOff /> : <Icon.Eye />}
                    </span>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Rol</label>
                  <select
                    value={selectedValue?.code || ''}
                    onChange={handleRoleChange}
                    className="form-select"
                  >
                    {roles.map((role) => (
                      <option key={role.code} value={role.code}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => setIsAddModalOpen(false)}
                  >
                    İptal
                  </button>
                  <button
                    disabled={isLoading}
                    type="submit"
                    className="btn btn-primary"
                  >
                    Ekle
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Edit Modal */}
      <div
        className={`modal fade ${isEditModalOpen ? 'show' : ''}`}
        id="edit-user"
        style={{ display: isEditModalOpen ? 'block' : 'none' }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Kullanıcı Güncelle</h5>
              <button
                type="button"
                className="btn-close close-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setIsEditModalOpen(false)}
              >
                <Icon.X className="react-feather-custom"></Icon.X>
              </button>
            </div>
            <div className="modal-body pt-0">
              <form onSubmit={handleUpdateAdminUser}>
                <div className="mb-3">
                  <label className="form-label">Kullanıcı Adı</label>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    value={updatedUser.username}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Rol</label>
                  <select
                    value={updatedUser.role}
                    onChange={handleRoleChange}
                    className="form-select"
                  >
                    {roles.map((role) => (
                      <option key={role.code} value={role.code}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="form-groupheads d-flex d-flex justify-content-between mb-4">
                                    <h2>Status</h2>
                                    <div className="active-switch">
                                        <label className="switch">
                                            <input 
                                                type="checkbox" 
                                                checked={isActive}
                                                onChange={handleStatusChange}
                                            />
                                            <span className="sliders round" />
                                        </label>
                                    </div>
                                </div> */}
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => setIsAddModalOpen(false)}
                  >
                    İptal
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Güncelle
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersModal;
